import { ru } from "vuetify/lib/locale";

export default {
  $vuetify: { ...ru },
  ...ru,
  navigation: {
    plantsCare: "Уход за растениями",
    shop: "Магазин",
    collection: "Коллекция",
  },

  header: {
    menu: {
      assortment: "Ассортимент",
      aboutHappyPlants: "О Happy Plants",
      inspiration: "Вдохновение",
      homePage: {
        header: "Главная страница",
        title: "Главная страница",
      },
      CollectionPage: {
        header: "Все товары",
        title: "Все товары",
      },
      caringPlants: {
        header: "Уход за растениями",
        title: "Принципы ухода за растениями",
      },
      ourCompany: {
        header: "Наша компания & B2B",
        title: "Наша компания & B2B",
      },
      santinoSystem: {
        header: "Система ухода Santino",
        title: "Система ухода за растениями",
      },
      Contact: {
        header: "Контакты",
        title: "Свяжитесь с нами",
      },
      selfWatering: {
        header: "Горшки с автополивом",
        title: "Система автополива Santino",
      },
      sustainability: {
        header: "Устойчивое развитие",
        title: "Устойчивое развитие",
      },
      blog: {
        header: "Советы и лайфхаки для любителей растений",
        title: "Читайте наш блог",
      },
      inspireTopics: {
        header: "Вдохновляйтесь актуальными темами",
      },
    },
    categories: {
      allProducts: "Все продукты",
      loading: "Загрузка категорий...",
      shoppingCart: "Корзина",
      goToCart: "Перейти в корзину",
    },
    aria: {
      logoLink: "ссылка на главную страницу",
      searchToggle: "Открыть поиск",
      menuToggle: "Открыть меню навигации",
    },
  },

  mobileDrawer: {
    title: {
      main: "главное",
    },
    menu: {
      home: "главная",
      assortment: {
        title: "ассортимент",
        items: {
          allProducts: "все продукты",
          shoppingCart: "корзина",
        },
      },
      about: {
        title: "о Happy Plants",
        items: {
          aboutUs: "О нас и B2B",
          sustainability: "Устойчивое развитие",
          plantCare: "Принципы ухода",
          santinoSystem: "Система автополива Santino",
          blog: "Читайте наш блог",
        },
      },
      inspiration: {
        title: "вдохновение",
      },
      contact: "контакты",
    },
    secondary: {
      terms: "условия и положения",
      privacy: "конфиденциальность",
    },
    footer: {
      whatsapp: "WHATS APP",
      b2b: "B2B",
      contact: "СВЯЗАТЬСЯ С НАМИ",
    },
  },

  searchField: {
    label: "Поиск товаров",
    searching: "Поиск товаров...",
    untitledProduct: "Без названия",
    results: {
      title: "Результаты поиска ({count})",
      sku: "Артикул",
      currency: "EUR",
    },
    noResults: {
      title: "Ничего не найдено",
      subtitle: 'Попробуйте изменить поисковый запрос для "{query}"',
    },
    recent: {
      title: "Недавние поиски",
    },
    popular: {
      selfWatering: "горшок с автополивом",
      indoorPlants: "комнатные растения",
      flowerPots: "цветочные горшки",
      plantCare: "уход за растениями",
      decorativePots: "декоративные горшки",
      outdoorPlanters: "уличные кашпо",
    },
    error: "Произошла ошибка при поиске",
  },

  shoppingCart: {
    ariaLabel: "корзина",
    title: "Ваша корзина",
    loading: "Загрузка товаров...",
    empty: "Ваша корзина пуста",
    subtotal: "Промежуточный итог:",
    currency: "EUR",
    checkoutNote: "Окончательная цена будет видна после оформления заказа",
    placeOrder: "Оформить заказ",
    minimumOrder: "мин. EUR",
  },

  home: {
    subtitle: "Более 16 лет мы производим",
    headline: {
      part1: "Уникальные цветочные горшки",
      part2: "с системой автополива",
      part3: "которые заботятся о ваших растениях",
      part4: "и экономят",
      water: "воду",
    },
    buttons: {
      plantCare: "Уход за растениями",
      shop: "Магазин",
    },
    categories: {
      title: "Откройте наш ассортимент",
      subtitle: "Умные горшки для красивого цветения",
      shopAll: "Смотреть все",
      loading: "Загрузка категорий...",
    },
    popularProducts: {
      title: "Самые популярные товары",
      subtitle: "Бестселлеры для легкого ухода за растениями",
      seeAll: "Смотреть все товары",
    },
    saleOffers: {
      title: "Специальные предложения",
      subtitle: "Бестселлеры для легкого ухода за растениями",
      seeAll: "Смотреть все товары",
    },
    potsTechnology: {
      subtitle: "Наша технология горшков",
      title: {
        part1: "Почему",
        plants: "растения",
        part2: "страдают?",
        part3: "как мы создали",
        smarter: "умный",
        part4: "способ",
        helpThemThrive: "помочь им расти",
      },
      buttons: {
        plantCare: "Технология ухода за растениями",
        shop: "Магазин",
      },
    },
    rootProblem: {
      title: "Что огорчает ваши растения?",
      paragraph1: {
        part1: "Даже самые красивые",
        highlight:
          "комнатные растения могут страдать, если их базовые потребности не удовлетворены.",
        part2: "И чаще всего проблема — это полив.",
      },
      paragraph2:
        "Будь вы любителем или профессионалом, эти трудности могут привести к одному — нездоровому растению.",
      solutionSubtitle: "Наше инновационное решение для здоровья растений",
      solutionTitle: "Вот почему мы переосмыслили цветочный горшок.",
      solutionText:
        "Растениям нужны не только добрые намерения. Им нужно правильное количество воды в нужное время. Но помнить, кому и когда поливать? Вот где большинство сталкивается с трудностями.",
    },
    santinoSystem: {
      subtitle: "Система ухода за растениями Santino™",
      title: {
        part1: "В каждом горшке Happy Plants —",
        systemName: "Система ухода Santino",
        part2: "— наша фирменная технология автополива,",
      },
    },
    smartPlants: {
      section1: {
        title: "Умный способ вырастить счастливые растения",
        text: {
          part1: "Кто бы вы ни были — новичок, энтузиаст или профессионал,",
          highlight: "Happy Plants снимает стресс ухода за растениями.",
        },
      },
      section2: {
        title: "Растения получают воду по требованию",
        text: {
          part1: "С",
          systemName: "Системой ухода Santino",
          part2:
            "в основе, наши горшки с автополивом решают самые частые проблемы, чтобы ваши растения и вы процветали.",
        },
      },
    },
    benefits: {
      title: "Как система автополива Santino помогает вашим любимым растениям?",
      options: {
        twinPot: {
          title: "Двойной горшок",
          subtitle: "Две камеры работают в гармонии",
          features: {
            doublePot: {
              title: "Двойной цветочный горшок",
              text: "маска-горшок и посадочный горшок: упрощают уход и дают дополнительные преимущества",
            },
            lessWater: {
              title: "Меньше воды",
              text: "легко контролировать уровень воды (для непрозрачных горшков)",
            },
            hecticSchedule: {
              title: "Решение для занятых",
              text: "удобный полив без протечек благодаря внутреннему резервуару",
            },
          },
        },
        healthyRoots: {
          title: "Здоровые корни — здоровый рост",
          subtitle: "Подход с заботой о корнях для долгой жизнеспособности.",
          features: {
            moistureProtection: {
              title: "Защита от избытка влаги",
              text: "Двойной горшок с резервуаром под корнями способствует их здоровью и защищает от застоя воды",
            },
            airCushion: {
              title: "Воздушная подушка",
              text: "двойной горшок создает воздушную прослойку для теплоизоляции, предотвращая переохлаждение или пересыхание корней",
            },
            soilAeration: {
              title: "Оптимальный рост и аэрация почвы",
              text: "дренажные отверстия внутреннего горшка обеспечивают циркуляцию воздуха, способствуя здоровью растений",
            },
          },
        },
        aesthetics: {
          title: "Безупречная эстетика, изысканный дизайн",
          subtitle: "Горшок красив, как и ваши растения",
          features: {
            cleanCozy: {
              title: "Чистота и уют",
              text: "горшок и поверхности остаются чистыми: без протечек и грязи",
            },
            visualControl: {
              title: "Окно для контроля воды",
              text: "легко следить за уровнем воды (для непрозрачных горшков)",
            },
            saucerFree: {
              title: "Без поддона",
              text: "удобный полив без протечек благодаря внутреннему резервуару",
            },
          },
        },
        savingWater: {
          title: "Экономия воды и времени",
          subtitle:
            "Инженерное решение для редкого полива — больше спокойствия, меньше догадок.",
          features: {
            lessFrequent: {
              title: "Полив реже",
              text: "Горшок и поверхности остаются чистыми: без протечек и грязи",
            },
            innerReservoir1: {
              title: "Внутренний резервуар",
              text: "резервуар и дренажные отверстия внутри горшка, под уровнем корней",
            },
            innerReservoir2: {
              title: "Внутренний резервуар",
              text: "резервуар и дренажные отверстия внутри горшка, под уровнем корней",
            },
          },
        },
      },
    },
    waterIsLife: {
      title: "Вода — это жизнь, если использовать правильно.",
      subtitle: "О нашей технологии автополива",
      text: {
        paragraph1: "У каждого растения свои потребности.",
        paragraph2: "Главное — регулярность, а не догадки.",
        paragraph3:
          "Растениям нужны не только добрые намерения — им нужно правильное количество воды в нужное время. Но помнить, кому и когда поливать? Вот где большинство сталкивается с трудностями.",
      },
    },
    waterDetails: {
      section1: {
        title: "Мы переосмыслили цветочный горшок",
        text: "Растения получают воду по требованию — когда и сколько им нужно.",
      },
      section2: {
        title: "Постоянная влажность. Без догадок.",
        text: 'Наши горшки с автополивом имеют встроенный резервуар в основании. Они используют капиллярный эффект ("фитиль"), чтобы поднимать воду в почву по мере необходимости. Этот естественный процесс обеспечивает растениям постоянный доступ к влаге.',
        benefits: {
          noOverwatering: "Больше никаких переливов",
          noUnderwatering: "Больше никаких пересушек",
          happyPlants: "Счастливые растения без усилий",
        },
      },
      section3: {
        title: "О технологии автополива",
        text: "Будь вы новичок или опытный цветовод, наша система автополива снимает стресс ежедневного ухода.",
        features: {
          upgrade: {
            title: "Апгрейд",
            text: "Серия Self-Watering+ выводит уход на новый уровень. Каждый горшок оснащен либо текстильным фитилем, либо инновационным картриджем Seramis® — высокоэффективным материалом из Германии, обеспечивающим оптимальный полив.",
          },
          soilMoisture: {
            title: "Оптимальная влажность почвы",
            text: "Корни впитывают воду из почвы, а встроенный резервуар позволяет поддерживать постоянную влажность для здорового роста.",
          },
        },
      },
    },
    shopWater: {
      cards: {
        selfWatering: {
          title: "Автополив",
          text: "Будь вы новичок или опытный цветовод, наша система автополива снимает стресс ежедневного ухода.",
        },
        selfWateringPlus1: {
          title: "Автополив+",
          text: "Двойной горшок с фитилем для оптимальной влажности. Для любителей орхидей",
        },
        selfWateringPlus2: {
          title: "Автополив+",
          text: "Двойной горшок с картриджем SERAMIS® для высокой влаго- и питательной емкости.",
        },
      },
      shopNow: "Купить сейчас",
    },
    moreExplore: {
      title: "Больше для изучения",
      subtitle: "Сотни профессионалов по всему миру уже доверяют Happy Plants.",
      cards: {
        shopNew: {
          title: "Новые модели",
          text: "Откройте для себя современные горшки с автополивом для дома, офиса и бизнеса.",
          button: "Купить сейчас",
        },
        aboutSystem: {
          title: "О системе автополива",
          text: "Инновационная технология автополива поддерживает идеальную влажность надолго.",
          button: "Подробнее",
        },
        plantsCare: {
          title: "Система ухода за растениями",
          text: "Happy Plants способствует здоровью растений благодаря дизайну: аэрация, баланс влажности и правильный дренаж.",
          button: "Подробнее",
        },
        sustainability: {
          title: "Устойчивое развитие",
          text: "Все продукты Happy Plants изготавливаются из перерабатываемых материалов, помогая уменьшить отходы и поддерживать.",
          button: "Подробнее",
        },
      },
    },
  },

  // Страница коллекций
  collection: {
    // Заголовок и хлебные крошки (ShopByCategory)
    header: {
      title: "Откройте наш ассортимент",
      titleWithCategory: "Коллекция",
      subtitle:
        "Каждый горшок уникален. Тщательно спроектирован и продуман — чтобы ваши растения (и вы) процветали.",
      breadcrumbs: {
        home: "Главная",
        allCollections: "Все коллекции",
      },
    },

    // Фильтры и сортировка (ShopFilters)
    filters: {
      search: "Поиск",
      appliedFilters: "Применённые фильтры:",
      total: "Всего:",
      products: "Товары",
      advicesAndTips: "Советы и рекомендации",
      sortBy: "Сортировать по",
      sortOptions: {
        priceLowHigh: "Цена от 0 до 100",
        priceHighLow: "Цена от 100 до 0",
        nameAZ: "Название A-Я",
        nameZA: "Название Я-A",
      },
      filtersTitle: "Фильтры",

      // Типы фильтров
      filterTypes: {
        potSize: "Размер горшка",
        potType: "Тип горшка",
        potShape: "Форма горшка",
        exteriorColor: "Внешний цвет",
        functionality: "Функциональность",
      },

      // Функциональность
      functionality: {
        waterControl: "Окно контроля воды",
        bottomPlug: "Дренажная пробка",
        indoor: "Для помещений",
        outdoor: "Для улицы",
        semiTransparent: "Полупрозрачный",
        orchids: "Для орхидей",
        windowBox: "Ящик на окно",
      },

      // Статусы
      loading: "Загрузка товаров...",
      noResults: "Товары не найдены",
      clearFilters: "Сбросить фильтры",
      loadMore: "Показать ещё",
      retry: "Повторить",
    },

    // Недавно просмотренные (RecentlyViewed)
    recentlyViewed: {
      title: "Вы недавно смотрели",
      subtitle: "Недавно просмотренный вами ассортимент.",
    },
  },

  // Страница продукта
  product: {
    // Breadcrumbs
    breadcrumbs: {
      home: "Главная",
      allCollections: "Все коллекции",
    },

    // Основная информация
    details: {
      skuNumber: "Артикул",
      readFullDescription: "Читать полное описание",
      potType: "Тип горшка",
      potShape: "Форма горшка",
      dimensions: "Размеры (см)",
      availableColors: "Доступные цвета",
      addToCart: "Добавить в корзину",

      // Количество
      quantity: {
        label: "Количество",
      },

      // Сообщения
      messages: {
        addedToCart: "Товар успешно добавлен в корзину!",
      },

      // Информация о платежах
      payment: {
        title: "Онлайн-оплата скоро появится.",
        description:
          "Однако вы можете оформить заявку на заказ через сайт. После отправки заявки менеджер свяжется с вами для подтверждения деталей и оплаты. Подробнее в",
        link: "Оформление заказа и доставка",
      },
    },

    // Описание продукта
    description: {
      title: "Описание товара",
      dimensionsTitle: "Размеры товара",
      faqTitle: "Ваши вопросы — наши ответы",

      // FAQ вопросы и ответы
      faq: {
        question1: {
          title: "Сложно ли ухаживать за орхидеями?",
          text: "Нет, с нашей системой автополива корни всегда увлажнены на нужном уровне без ежедневного полива.",
        },
        question2: {
          title: "Подойдет ли горшок к моему интерьеру?",
          text: "Безусловно — каждый горшок Arte-Dea выполнен в лаконичном и элегантном стиле, подходящем к любому пространству.",
        },
        question3: {
          title: "Что если я забуду полить растение?",
          text: "Не переживайте — встроенный резервуар обеспечивает орхидею влагой на несколько дней, даже если вы заняты.",
        },
      },
    },

    // Другие продукты
    otherProducts: {
      title_part_1: "Больше из",
      title_part_2: "коллекции",
      subtitle:
        "Ищете подходящий стиль? Изучите другие товары из этой коллекции ниже.",
    },
  },

  // Страница Principles (Принципы ухода за растениями)
  principles: {
    // Breadcrumbs
    breadcrumbs: {
      home: "Главная",
      principles: "Принципы ухода за растениями",
    },

    // Заголовок
    header: {
      title: "Принципы ухода за растениями",
      subtitle:
        "Помогаем тем, кто заботится о растениях. Мягкие рекомендации для садоводов и любителей цветов.",
    },

    // Для кого наши горшки
    forWhom: {
      title: "Для кого горшки Happy Plants?",
      subtitle:
        "Пять типов любителей растений и садоводов, которым подходят наши горшки и уход",
      types: {
        newParents: "Новые владельцы растений",
        experienced: "Опытные садоводы",
        indoor: "Любители домашнего уюта",
        lovers: "Любители цветов и растений",
        gifters: "Покупатели подарков",
      },
    },

    // 7 принципов
    sevenPrinciples: {
      mainTitle: "Принципы Santino для здоровых растений",
      mainSubtitle:
        "Создаём качественные продукты для ухода за растениями, внедряя новые идеи",
      shopButton: "Смотреть все горшки",
      bottomTitle:
        "Для реализации всех 7 принципов мы разработали исключительные цветочные горшки",

      principles: {
        alive: {
          title: "Растения живые",
          text: 'Растение — живой организм: оно растет, дышит, испаряет влагу и нуждается в воде, питательных веществах, свете, правильной среде и температуре. Ему также нужна пересадка, оно может размножаться и — как и мы — может быть "счастливым" или страдать.',
        },
        unique: {
          title: "Каждое растение уникально",
          text: "Каждое растение индивидуально, но всем нужны подходящие условия для роста и защиты. Это включает персональный уход: полив, подкормку, обработку и мониторинг здоровья — всё по природному ритму.",
        },
        soil: {
          title: "Используйте правильный грунт",
          text: "Используйте подходящий субстрат — правильную почву, дренаж, инструменты и удобрения, соответствующие потребностям растения.",
        },
        pot: {
          title: "Выберите правильный горшок",
          text: "Выберите подходящий горшок — размер, форма, функциональность и даже цвет влияют на благополучие растения.",
        },
        water: {
          title: "Не заливайте",
          text: "Большинство растений не любят избыток влаги. Перелив может вызвать гниль корней, особенно у неводных видов. Обеспечьте хороший дренаж, особенно для уличных горшков.",
        },
        heat: {
          title: "Избегайте перегрева",
          text: "Растения чувствительны к температуре. Слишком жарко или холодно — и почва, вода и воздух вокруг растения пересыхают, что мешает росту.",
        },
        love: {
          title: "Любите свои растения",
          text: "Восхищайтесь и любите свои растения! Дарите им внимание, заботу и терпение. В ответ они порадуют вас красотой, жизненной силой и чувством радости.",
        },
      },
    },

    // Блок с градиентом
    gradient: {
      selfWatering: {
        title: "Автополив для стабильной влажности",
        text: "Горшки Happy Plants оснащены встроенным резервуаром и фитильной системой, которая подаёт воду по мере необходимости. Это исключает догадки и предотвращает перелив и пересушку.",
      },
      healthyRoots: {
        title: "Здоровые корни благодаря аэрации",
        text: "Двойная конструкция создает воздушную подушку вокруг корней. Дренажные отверстия и внутренний резервуар защищают корни от застоя воды и обеспечивают доступ воздуха.",
      },
      cleanDesign: {
        title: "Чистый, экономящий время дизайн",
        text: "Эти горшки не требуют поддона и имеют окно для контроля уровня воды, что сохраняет поверхности чистыми и предотвращает пятна.",
      },
    },

    // Призыв к действию
    callToAction: {
      title: "Хотите сделать ваши растения счастливее?",
      text: "Изучите весь ассортимент горшков Happy Plants с автополивом и подарите своим зелёным друзьям достойный уход.",
      button: "Смотреть все горшки",
    },
  },

  // Страница Plants Care System
  plantsCareSystem: {
    // Breadcrumbs
    breadcrumbs: {
      home: "Главная",
      system: "Система ухода за растениями",
    },

    // Заголовок
    header: {
      title: "Система ухода за растениями",
      subtitle: "Умно. Стильно. Для реальной жизни",
    },

    // At the heart section
    heart: {
      title: "В каждом горшке Happy Plants",
      text: "Система ухода за растениями Santino — наша фирменная технология автополива, объединяющая все преимущества Happy Plants для здоровья растений и радости владельцев.",
      button: "Купить горшки для ухода за растениями",
    },

    // All-in-one section
    allInOne: {
      title: "Комплексное решение для ухода",
      text: "Система ухода за растениями Santino™ объединяет все преимущества Happy Plants™, чтобы ваши растения были здоровы, а уход за ними — простым.",
      button: "Купить сейчас",

      features: {
        feature1: "Новые владельцы растений",
        feature2: "Встроенная система автополива для стабильного увлажнения",
        feature3:
          "Индикатор уровня воды — больше никаких переливов и пересушек",
        feature4:
          "Улучшенная вентиляция для защиты корней и предотвращения гнили",
        feature5: "Дизайн с минимальным уходом для современной жизни",
      },
    },

    // Self-Watering section
    selfWatering: {
      title: "Технология автополива как часть системы ухода",
      subtitle:
        "Будь вы новичок или опытный цветовод, наша система автополива избавляет от стресса ежедневного ухода.",
      button: "Подробнее об автополиве",

      upgrade: {
        title: "Апгрейд",
        text: "Серия Self-Watering+ выводит уход на новый уровень. Каждый горшок оснащён либо текстильным фитилём, либо инновационным керамическим картриджем Seramis® (Германия) — для идеального полива.",
      },

      moisture: {
        title: "Оптимальная влажность почвы",
        text: "Корни впитывают воду из почвы, а встроенный резервуар позволяет поддерживать постоянную влажность для здорового роста.",
      },
    },
  },

  // Страница Sustainability (Recycling/CycleBloom)
  sustainability: {
    // Breadcrumbs
    breadcrumbs: {
      home: "Главная",
      sustainability: "Устойчивое развитие",
    },

    // Заголовок и первый блок
    intro: {
      title: "Любое великое изменение начинается с простого шага",
      paragraph1:
        "В Happy Plants мы верим, что у каждого горшка есть своя история, и она не заканчивается, когда горшок треснул, выцвел или стал не нужен.",
      paragraph2:
        "С помощью CycleBloom — нашей внутренней системы переработки — мы даём использованным горшкам вторую жизнь, превращая вчерашние материалы в завтрашний красивый и функциональный дизайн.",
      paragraph3:
        "Это наш способ защищать природу, сокращать отходы и строить будущее, где устойчивость и стиль идут рука об руку.",
    },

    // Процесс переработки
    process: {
      step1: {
        title: "Сбор, восстановление и сортировка по цвету",
        text: "Мы начинаем со сбора и сортировки по цвету использованных или повреждённых горшков от клиентов, магазинов, производства и партнёров. Они готовятся к новой жизни вместо того, чтобы попасть на свалку.",
      },
      step2: {
        title: "Дробление и измельчение",
        text: "Отсортированные горшки измельчаются в мелкие однородные хлопья — до 10 мм. Такой материал идеально подходит для дальнейшей переработки и равномерного плавления при формовке.",
      },
      step3: {
        title: "Упаковка и хранение",
        text: "Измельчённый материал хранится в больших промышленных мешках, каждая партия — отдельно, до момента производства.",
      },
      step4: {
        title: "Формование новых горшков",
        text: "С помощью традиционных термопластовых машин мы превращаем переработанный материал в новые цветочные горшки. Без добавления первичного сырья — только 100% переработанный полипропилен.",
      },
    },

    // Результат
    result: {
      title: "Результат?",
      paragraph1:
        "Новое поколение цветочных горшков: прочные, стильные и экологичные. Каждый полностью изготовлен из переработанного материала и снова пригоден для переработки.",
      paragraph2:
        "Это больше, чем просто горшок — это часть цикличного будущего, где красота сочетается с ответственностью.",
    },
  },

  // Страница Self-Watering System
  selfWateringSystem: {
    // Breadcrumbs
    breadcrumbs: {
      home: "Главная",
      selfWatering: "Система автополива",
    },

    // Заголовок
    header: {
      title: "Система автополива",
      subtitle: "Умно. Стильно. Для реальной жизни",
    },

    // Секция "Что такое автополив?"
    whatIs: {
      title: "Что такое автополив?",
      text: "Многие любители растений сталкиваются с этой проблемой: как обеспечить постоянный уровень влаги для каждого зелёного друга. Растения не живут «наугад» — им нужно стабильное количество воды в нужный момент. Но помнить, когда и сколько поливать каждый горшок, бывает сложно. Именно поэтому мы переосмыслили цветочный горшок: наш горшок Happy Plants с системой самополива устраняет догадки и делает уход проще.",
      button: "Подробнее",
    },

    // Секция "Комплексное решение"
    allInOne: {
      title: "Комплексное решение для ухода",
      text: 'Ключевая особенность автополива — встроенный резервуар в основании. Через фитильную систему вода постепенно поднимается к корням, обеспечивая растения влагой "по требованию".',
      features: {
        feature1:
          "Постоянная влажность без догадок. Большой внутренний резервуар обеспечивает стабильную подачу воды.",
        feature2:
          "Защита корней. Двойные стенки создают воздушную подушку, предотвращая гниль и переохлаждение.",
        feature3:
          "Поливать нужно реже. Внутренний резервуар долго сохраняет влагу.",
        feature4:
          "Чисто и удобно. Горшки не требуют поддона и имеют окно для контроля уровня воды (для непрозрачных моделей).",
        feature5: "Минимальный уход — идеально для занятых людей",
      },
      button: "Купить сейчас",
    },

    // Секция "Мы переосмыслили"
    reimagined: {
      title: "Мы переосмыслили цветочный горшок",
      text: "Растения получают воду по требованию — когда и сколько им нужно.",
    },

    // Секция "Постоянная влажность"
    consistentMoisture: {
      title: "Постоянная влажность. Без догадок.",
      text: 'Наши горшки с системой самополива оснащены встроенным водным резервуаром в основании. Они используют капиллярный эффект, также известный как «фитильный метод», чтобы поднимать воду вверх в почву через дренажные отверстия внутреннего горшка по мере необходимости растения. Этот естественный процесс обеспечивает постоянный доступ растения к нужному количеству влаги. Второе преимущество — аэрация почвы, которая способствует развитию корней и улучшает общее состояние растения.',
      benefits: {
        noOverwatering: "Больше никаких переливов",
        noUnderwatering: "Больше никаких пересушек",
        happyPlants: "Счастливые растения без усилий",
      },
    },
  },

  // Страница Hashtag
  hashtag: {
    // Breadcrumbs
    breadcrumbs: {
      home: "Главная",
      hashtag: "Хэштег #",
    },

    // Заголовок страницы
    header: {
      description: "Всё, что вы найдёте по тегу",
      byHappyPlants: "от HappyPlants",
    },

    // Секция с продуктами
    relevantProducts: {
      title: "Похожие товары",
      subtitle: "Изучите товары по тегу #",
    },

    // Секция со статьями
    relevantArticles: {
      title: "Похожие статьи",
      subtitle: "Изучите статьи по тегу #",
    },
  },

  // Страница Contact Us
  contactUs: {
    // Заголовок
    header: {
      title: "Контакты",
      subtitle:
        "В HappyPlants ваш комфорт — наш приоритет. Если вам что-то нужно, мы всегда готовы помочь.",
    },

    // Информационные секции
    sections: {
      headOffice: "Головной офис",
      phone: "Телефон",
      email: "Электронная почта",
      companyDetails: "Реквизиты компании",
    },

    // Форма
    form: {
      firstName: {
        label: "Имя",
        placeholder: "Имя",
      },
      lastName: {
        label: "Фамилия",
        placeholder: "Фамилия",
      },
      email: {
        label: "Ваш email",
        placeholder: "Email",
      },
      phone: {
        label: "Телефон (необязательно)",
        placeholder: "+373 XX XXX XXX",
      },
      topic: {
        label: "Тема",
        placeholder: "Выберите вариант",
      },
      message: {
        label: "Ваше сообщение",
        placeholder: "Напишите ваше сообщение здесь",
      },
      submitButton: "Отправить!",
    },

    // Валидация
    validation: {
      required: "Это поле обязательно",
      invalidEmail: "Некорректный email",
    },

    // Сообщения
    messages: {
      success: "Ваше сообщение успешно отправлено!",
      error: "Произошла ошибка. Пожалуйста, попробуйте ещё раз.",
    },

    // Дефолтные топики
    defaultTopics: {
      general: "Общий вопрос",
      partnership: "Партнёрство",
      pricing: "Цены",
      other: "Другое",
    },
  },

  // Страница Blog
  blog: {
    // Breadcrumbs
    breadcrumbs: {
      home: "Главная",
      blog: "Блог Happy Plants",
    },

    // Заголовок
    header: {
      title: "Блог Happy Plants",
      subtitle: "Советы, идеи и вдохновение для любителей растений",
    },
  },

  // Страница About Us & B2B Cooperation
  aboutB2B: {
    // Breadcrumbs
    breadcrumbs: {
      home: "Главная",
      aboutB2B: "О нас и B2B сотрудничество",
    },

    // Заголовок
    header: {
      title: "О нас и B2B сотрудничество",
      subtitle: "Дарим цветочным горшкам новую жизнь.",
    },

    // Секция "We are Happy Plants"
    weAre: {
      title: "Мы — Happy Plants",
      subtitle:
        "Европейский производитель готовых к продаже горшков с автополивом с успешным опытом поставок высокомаржинальных и быстро продающихся товаров крупнейшим ритейлерам и дистрибьюторам по всему миру.",
    },

    // Секция "Your customers want"
    customersWant: {
      title: "Вашим клиентам нужно больше, чем просто горшки.",
      text: "Им важны удобство, элегантность и решения, которые экономят время и воду — и мы это обеспечиваем.",
    },

    // Секция "Why work with us"
    whyWorkWithUs: {
      title: "Почему работать с нами",
      features: {
        provenSeller:
          "Доказанная эффективность — наши горшки с автополивом успешно продаются в США и ЕС как под нашим брендом, так и под частной маркой.",
        retailReady:
          "Готовы к продаже — каждый продукт упакован, промаркирован и готов к выкладке.",
        designThatSells:
          "Дизайн, который продаёт — привлекательные и функциональные решения стимулируют импульсные покупки и повторные продажи.",
        cleanConvenient:
          "Чисто и удобно. Горшки не требуют поддона и имеют окно для контроля уровня воды (для непрозрачных моделей).",
        highProfitMargins:
          "Высокая маржинальность — штабелируемая конструкция экономит место и снижает расходы на доставку и хранение.",
      },
      button: "Купить сейчас",
    },

    // Секция "Our Edge"
    ourEdge: {
      title: "Наше преимущество",
      features: {
        fullCycle:
          "Полный цикл производства — от идеи до упаковки на собственной фабрике в Молдове.",
        capacity:
          "Гарантированные объёмы — 150 000 горшков в месяц, стабильное качество и своевременные поставки.",
        designSells:
          "Дизайн, который продаёт — привлекательные и функциональные решения стимулируют импульсные покупки и повторные продажи.",
        ecoResponsible:
          "Эко-ответственность — используем переработанный и первичный пластик, соблюдая стандарты устойчивого развития без ущерба качеству.",
        logistics:
          "Логистика без забот — доставка DDP/DDU в США за 40 дней, надёжные партнёры по перевозке.",
      },
      button: "Купить сейчас",
    },

    // Секция "Products That Fit"
    productsFit: {
      title: "Продукты для вашего рынка",
      features: {
        indoorOutdoor: "Горшки с автополивом для дома и улицы",
        orchidPots: "Премиальные горшки для орхидей с фитилём",
        decorativeOptions: "Модели с подставками и декором",
        multipleOptions:
          "Разнообразие форм, размеров и цветов — готовы к вашей частной марке",
      },
      button: "Купить сейчас",
    },

    // Секция "The Opportunity"
    opportunity: {
      title: "Возможности",
      paragraph1:
        'Мы помогаем ритейлерам увеличить оборот категории и развивать сегмент "удобного садоводства" с готовыми к продаже горшками.',
      paragraph2:
        "Хотите расширить ассортимент, запустить сезонную акцию или создать эксклюзивную линейку? У нас есть всё: поставки, качество и опыт.",
    },

    // Секция контактной формы
    contactForm: {
      title: "Обсудим ваши цели по ассортименту.",
      contact: {
        title: "Контакты",
      },
      sections: {
        headOffice: "Головной офис",
        phone: "Телефон",
        email: "Электронная почта",
      },
      form: {
        firstName: {
          label: "Имя",
          placeholder: "Имя",
        },
        lastName: {
          label: "Фамилия",
          placeholder: "Фамилия",
        },
        email: {
          label: "Ваш email",
          placeholder: "Email",
        },
        phone: {
          label: "Телефон (необязательно)",
          placeholder: "+373 XX XXX XXX",
        },
        topic: {
          label: "Тема",
          placeholder: "Выберите вариант",
        },
        message: {
          label: "Ваше сообщение",
          placeholder: "Напишите ваше сообщение здесь",
        },
        submitButton: "Отправить!",
      },
      validation: {
        required: "Это поле обязательно",
        invalidEmail: "Некорректный email",
      },
      messages: {
        success: "Ваше сообщение успешно отправлено!",
        error: "Произошла ошибка. Пожалуйста, попробуйте ещё раз.",
      },
      defaultTopics: {
        general: "Общий вопрос",
        partnership: "Партнёрство",
        pricing: "Цены",
        other: "Другое",
      },
    },
  },

  // Страница статьи блога
  blogArticle: {
    breadcrumbs: {
      home: "Главная",
      blog: "Блог Happy Plants",
    },
    title: "Блог Happy Plants",
    subtitle: "Советы, идеи и вдохновение для любителей растений",
  },

  // Компонент Explore Hashtags
  exploreHashtags: {
    title: "Больше хэштегов Happy Plants",
  },

  // Корзина покупок
  shoppingCartPage: {
    title: "Ваша корзина",
    subtitle:
      "После получения вашего запроса наш менеджер проверит наличие и свяжется с вами для подтверждения деталей и оформления заказа.",
    emptyCart: "Ваша корзина пуста",
    loading: "Загрузка корзины...",

    // Детали товара
    volumeSize: "Объем + Размер",
    color: "Цвет",

    // Цены и количество
    quantity: "Количество",
    pot: "горшок",
    pots: "горшков",

    // Checkout секция
    checkout: {
      title: "Оформление заказа",
      subtotalProducts: "Итого товаров:",
      volume: "Объем",
      minimumOrder: "Минимальная сумма заказа — EUR",
      currently: "сейчас EUR",
      minimumOrderWarning: "Минимальная сумма заказа",
      termsAgreement:
        'Нажимая "Оформить заказ", вы подтверждаете, что ознакомились с условиями доставки и соглашаетесь с нашими Правилами и условиями.',
      placeOrder: "Оформить заказ",
    },

    // Информационное сообщение
    paymentInfo: {
      title: "Онлайн-оплата скоро появится.",
      text: "Вы можете оформить заявку на заказ через сайт. После отправки заявки менеджер свяжется с вами для подтверждения деталей и оплаты. Подробнее в разделе Оформление заказа и доставка.",
    },

    // Подтверждения
    removeConfirm: "Вы уверены, что хотите удалить этот товар из корзины?",
  },

  // Форма чекаута
  checkoutForm: {
    title: "Оформление заказа",
    billingAddress: "Платёжный адрес:",
    billingAddressText:
      "Используется для оплаты и выставления счета. Должен совпадать с данными вашей карты или способа оплаты.",
    shippingAddress: "Адрес доставки:",
    shippingAddressText:
      "Адрес, по которому будет доставлен заказ. Можно указать другой адрес, отличный от платёжного.",

    emptyCart: "Ваша корзина пуста",

    // Предупреждения
    minimumOrderWarning: "Минимальная сумма заказа — EUR",
    currentTotal: "Текущая сумма: EUR",

    // Кнопки
    placeOrder: "Оформить заказ",
    creatingOrder: "Создание заказа...",

    // Ошибки
    unexpectedError:
      "Произошла непредвиденная ошибка. Пожалуйста, попробуйте ещё раз.",

    // Сводка заказа
    orderSummary: {
      title: "Сводка заказа",
      productsTotal: "Итого товаров:",
      items: "Товаров:",
      item: "товар",
      itemsPlural: "товаров",
      shippingCost: "Стоимость доставки",
      willBeInformed: "Будет сообщено после оформления",
      orderDetails: "Детали заказа:",
    },

    // Информация об оплате
    paymentInfo: {
      title: "Онлайн-оплата скоро появится.",
      text: "Вы можете оформить заявку на заказ через сайт. После отправки заявки менеджер свяжется с вами для подтверждения деталей и оплаты. Подробнее в разделе Оформление заказа и доставка.",
    },
  },

  // Форма адреса доставки
  deliveryAddressForm: {
    title: "Адрес доставки",

    // Поля формы
    fields: {
      email: "*Email",
      emailPlaceholder: "Email",
      name: "*Имя",
      namePlaceholder: "Имя",
      surname: "*Фамилия",
      surnamePlaceholder: "Фамилия",
      businessName: "Название компании",
      businessNamePlaceholder: "Название компании",
      addressLine1: "Адрес, строка 1",
      addressLine1Placeholder: "Адрес, строка 1",
      addressLine2: "Адрес, строка 2",
      addressLine2Placeholder: "Адрес, строка 2",
      zipCode: "*Почтовый индекс",
      zipCodePlaceholder: "Почтовый индекс",
      city: "*Город",
      cityPlaceholder: "Город",
      province: "*Область/регион",
      provincePlaceholder: "Область/регион",
      country: "*Страна",
      countryPlaceholder: "Выберите страну",
      noteToCarrier: "Комментарий для курьера",
      noteToCarrierPlaceholder: "Комментарий для курьера",
      phoneNumber: "*Телефон",
      phoneNumberPlaceholder: "+40 78 580 4972",
    },

    // Валидация
    validation: {
      emailRequired: "Email обязателен",
      emailInvalid: "Email должен быть корректным",
      fieldRequired: "Поле обязательно",
      minCharacters: "Минимум 2 символа",
      phoneRequired: "Телефон обязателен",
      phoneInvalid: "Некорректный номер телефона",
      zipRequired: "Почтовый индекс обязателен",
      zipInvalid: "Некорректный почтовый индекс",
    },

    // Кнопки и состояния
    save: "Сохранить",
    changeAddress: "Изменить адрес",
    loadingCountries: "Загрузка стран...",
    noCountries: "Нет доступных стран",
  },

  // Форма адреса для счета
  invoiceAddressForm: {
    title: "Адрес для выставления счета",
    useSameAddress: "Использовать тот же адрес, что и для доставки",

    // Используем те же поля что и в deliveryAddressForm
    fields: {
      email: "*Email",
      emailPlaceholder: "Email",
      name: "*Имя",
      namePlaceholder: "Имя",
      surname: "*Фамилия",
      surnamePlaceholder: "Фамилия",
      businessName: "Название компании",
      businessNamePlaceholder: "Название компании",
      addressLine1: "Адрес, строка 1",
      addressLine1Placeholder: "Адрес, строка 1",
      addressLine2: "Адрес, строка 2",
      addressLine2Placeholder: "Адрес, строка 2",
      zipCode: "*Почтовый индекс",
      zipCodePlaceholder: "Почтовый индекс",
      city: "*Город",
      cityPlaceholder: "Город",
      province: "*Область/регион",
      provincePlaceholder: "Область/регион",
      country: "*Страна",
      countryPlaceholder: "Выберите страну",
      noteToCarrier: "Комментарий для курьера",
      noteToCarrierPlaceholder: "Комментарий для курьера",
      phoneNumber: "*Телефон",
      phoneNumberPlaceholder: "+40 78 580 4972",
    },

    // Валидация
    validation: {
      emailRequired: "Email обязателен",
      emailInvalid: "Email должен быть корректным",
      fieldRequired: "Поле обязательно",
      minCharacters: "Минимум 2 символа",
      phoneRequired: "Телефон обязателен",
      phoneInvalid: "Некорректный номер телефона",
      zipRequired: "Почтовый индекс обязателен",
      zipInvalid: "Некорректный почтовый индекс",
    },

    // Кнопки
    save: "Сохранить",
    changeAddress: "Изменить адрес",
    loadingCountries: "Загрузка стран...",
    noCountries: "Нет стран",
  },

  // Подтверждение заказа
  orderConfirmation: {
    thankYou: "Спасибо,",
    subtitle: "Ваши растения будут счастливы как никогда раньше",
    emailSent: "Мы отправили вам счет и информацию о заказе на email",
    here: "здесь",

    // Детали заказа
    productsTotal: "Итого товаров:",
    items: "Товаров:",
    itemsCount: "шт.",
    orderId: "Номер заказа:",

    // Кнопки
    continueShopping: "Продолжить покупки",
    downloadInvoiceButton: "Скачать счет",
  },

  // Список деталей заказа
  orderDetails: {
    title: "Детали заказа:",
    volumeSize: "Объем + Размер",
    color: "Цвет",
    productImage: "Изображение товара",
    product: "Товар",
  },

  // Компонент Tips & Ideas
  tipsIdeas: {
    title: "Советы, идеи и вдохновение",
    subtitle:
      "Узнайте о грамотном уходе за растениями, устойчивом дизайне и лучших способах использовать горшки Happy Plants.",
    readNow: "Читать сейчас",
    hashtagsTitle: "Хэштеги",
    hashtagsText:
      "Используйте хэштеги, чтобы мгновенно находить связанные товары, статьи и вдохновение. Один клик — и всё нужное у вас под рукой.",
  },

  // Футер
  footer: {
    site: "Сайт",
    shopHappyPlants: "Магазин Happy Plants",
    clientServiceTitle: "Сервис для клиентов",
    menu: {
      home: "Главная",
      shop: "Магазин",
      sustainability: "Устойчивое развитие",
      selfWatering: "Автополив",
      careSystem: "Система ухода",
      blog: "Блог",
      about: "О нас и B2B",
    },
    clientService: {
      contact: "Связаться с нами",
      shipping: "Доставка",
      terms: "Условия оформления заказа",
      privacy: "Конфиденциальность",
      retailer: "Стать партнером",
    },
    legal: {
      terms: "Правила и условия",
      imprint: "Импрессум",
      cookies: "Cookies",
      privacy: "Политика конфиденциальности",
    },
    copyright: "&copy; Happy Plants™ 2025",
    developedBy: "Веб-дизайн и разработка Amark.pro",
  },

  // Общие тексты
  common: {
    readNow: "Читать сейчас",
    readMore: "Читать далее",
    learnMore: "Узнать больше",
    buyNow: "Купить сейчас",
    addToCart: "Добавить в корзину",
    shop: "Магазин",
    shopNow: "Купить сейчас",
    explore: "Изучить",
  },
};
